export interface AuthPhoneValue {
    country: string;
    country_code: string;
    mobile: string;
    username: string;
}

export const EMPTY_AUTH_PHONE: AuthPhoneValue = {
    country: 'IN',
    country_code: '91',
    mobile: '',
    username: '',
};

export type GenerateOtpPayload = {
    mode: string;
    username: string;
    country: string;
};

export type LoginPayload = {
    username: string;
    country: string;
    otp: string;
};

export type RegisterPayload = {
    country: string;
    country_code: string;
    mobile: string;
    otp: string;
    name: string;
    referrer?: string | null;
};
